/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { GlobalContext } from '../contexts';

export const useGlobalLang = <T>(): T => useContext(GlobalContext).lang as T;
